import "core-js/modules/es.regexp.exec.js";
export function isNumeric(score) {
  //@ts-expect-error TODO: fix this
  return /^\d+(.\d+)?$/.test(score);
}